<div class="d-grid fr-1 gap-2 banner-list">
  @for (banner of banners; track banner.id) {
    <div class="banner-wrap" @fadeSlideInOut>
      <mo-notification-banner-list-item
        [banner]="banner"
        (closeBanner)="closeBanner(banner)"
      ></mo-notification-banner-list-item>
    </div>
  }
</div>
